import {memo} from 'react';
import {ItemsTable} from './ItemsTable';
import {translate} from '../../utils';

export const ReservationPanel = memo(({reservationCode, alreadyInvoicedItems, collection, toggleSelection, searchReservation}) => {
    return <div className={'vstack gap-1'}>
        <div className={'text-right'}>
            <button type="button" className="btn btn-default-clear btn-sm" onClick={searchReservation}>
                {translate('frontend', 'Search reservation')}
            </button>
        </div>
        <div className="box box-solid">
            <div className="box-header">
                <h3 className="box-title">{translate('frontend', 'RESERVATION')} {reservationCode}</h3>
            </div>
            <div className="box-body">
                <ItemsTable alreadyInvoicedItems={alreadyInvoicedItems} collection={collection} toggleSelection={toggleSelection}/>
            </div>
        </div>
    </div>;
});
ReservationPanel.displayName = 'ReservationPanel';
